import TemplateRenameModal from "./TemplateRenameModal.js";
export default TemplateRenameModal;
